'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseGesturesSwipeable = require('@bibliocommons/base-gestures-swipeable');

var _baseGesturesSwipeable2 = _interopRequireDefault(_baseGesturesSwipeable);

var _baseAccessibilityManageFocus = require('@bibliocommons/base-accessibility-manage-focus');

var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sidebar = function (_BcReactComponent) {
  _inherits(Sidebar, _BcReactComponent);

  function Sidebar(props) {
    _classCallCheck(this, Sidebar);

    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));

    _this.bindAll('toggleFocus');
    return _this;
  }

  _createClass(Sidebar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._sidebar.addEventListener('transitionend', this.toggleFocus);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._sidebar.removeEventListener('transitionend', this.toggleFocus);
    }
  }, {
    key: 'toggleFocus',
    value: function toggleFocus() {
      if (this.props.open) {
        this.props.captureFocus(this._sidebar);
      } else {
        this.props.restoreFocus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var sidebarClassNames = (0, _classnames2.default)(this.props.sidebarClass, 'col-xs-10 col-sm-8 col-md-7 col-lg-3 cp-sidebar');

      return _react2.default.createElement(
        _baseGesturesSwipeable2.default,
        { onSwipedLeft: this.props.drawerActions.toggle },
        _react2.default.createElement('div', { className: 'sidebar-overlay', onClick: this.props.drawerActions.toggle }),
        _react2.default.createElement(
          'section',
          { className: sidebarClassNames, ref: function ref(el) {
              _this2._sidebar = el;
            } },
          this.props.children
        )
      );
    }
  }]);

  return Sidebar;
}(_baseBcReactComponent2.default);

Sidebar.propTypes = {
  drawerActions: _react.PropTypes.shape({
    toggle: _react.PropTypes.func.isRequired
  }),
  sidebarClass: _react.PropTypes.string
};

Sidebar.defaultProps = {
  sidebarClass: ''
};

exports.default = (0, _baseAccessibilityManageFocus2.default)(Sidebar);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drawer/lib/components/sidebar/components/Sidebar.component.js
// module id = 1065
// module chunks = 1